import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { NgChartsModule } from 'ng2-charts';

import { PrimengModule } from '../primeng/primeng.module';
import { MxComponentsModule } from './components/mx.components.module';
import { MxDirectivesModule } from './directives/mx.directives.module';
import { MxPipesModule } from './pipes/mx.pipes.module';
import { SzUiModule } from './components/sz/sz-ui.module';

@NgModule({
  imports: [
    CommonModule,
    I18NextModule,
    PrimengModule,
    ReactiveFormsModule,
    FormsModule,
    NgChartsModule
  ],
  exports: [
    CommonModule,
    PrimengModule,
    I18NextModule,
    ReactiveFormsModule,
    FormsModule,
    MxDirectivesModule,
    MxPipesModule,
    MxComponentsModule,
    NgChartsModule,
    SzUiModule
  ],
})
export class MxSharedModule {}
